import { combine, withCallback, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { toaster } from 'utils/toast-wrapper'
import { admin } from 'routes/route.map'

import { StoreContext } from 'store/context'
import TeamsAddComponent from './component'

export const TeamsAdd = combine(
  withContext(
    'adminTeamsService',
    ServicesContext,
    ({ adminTeamsService }) => adminTeamsService
  ),
  withContext('appStore', StoreContext),
  withCallback(
    'onSubmit',
    ({ adminTeamsService, appStore }, { history }) =>
      async (teamsDTO) => {
        await adminTeamsService.createTeam(teamsDTO)
        appStore.adminTeams.onTeamAdded()
        toaster.info('Team has been successfully created')
        history.push(admin.teams())
      },
    []
  )
)(TeamsAddComponent)
